// The /tools/* pages that fly-social.com server-renders.
//
// WHY THIS FILE EXISTS, AND WHY IT IS PLAIN JS AT THE REPO ROOT
// ------------------------------------------------------------
// /tools/* is excluded from SSR wholesale (see isPublicRoute in server.js and
// in src/entry-server.tsx). That exclusion was the right default: a lot of the
// 44 tools reach for Google Maps, canvas or html2canvas, and a page that
// renders beautifully for Googlebot but no longer runs for a visitor is a far
// worse outcome than a missing H1. But it also meant these pages went out as an
// empty shell, so an SEO audit read every one of them as "missing H1": the
// heading and the copy exist, they were just never rendered on the server.
//
// The paths below are the audited exceptions. server.js is plain JS and cannot
// import from src/, while the route table that preloads the chunk is TypeScript
// under src/routes/marketingRoutes.ts. Both read THIS file, so the gate and the
// route table cannot drift apart: a path listed here but missing from the table
// would be server-rendered as the empty Suspense fallback, which is the exact
// bug we are fixing.
//
// BEFORE ADDING A PATH HERE
// -------------------------
// Read the page component and everything it imports, and confirm that nothing
// touches window, document, localStorage, sessionStorage, navigator, matchMedia,
// IntersectionObserver or canvas at module load or during render. Inside a
// useEffect is fine, that never runs on the server. Then add the matching
// lazyRoute entry to src/routes/marketingRoutes.ts, and load the page in a real
// browser to confirm it still runs and hydrates without a React #418/#419.

/** Tool pages that are server-rendered. Exact paths, no trailing slash. */
export const SSR_TOOL_PAGES = [
  '/tools/ai-search-visibility',
  '/tools/best-time-to-post',
  '/tools/brand-voice-analyzer',
  '/tools/caption-generator',
  '/tools/citation-audit-deep',
  '/tools/citation-checker',
  '/tools/competitor-analysis-nearby',
  '/tools/competitor-social-audit',
];

const LOOKUP = new Set(SSR_TOOL_PAGES);

/**
 * True when this URL is one of the server-rendered tool pages.
 * Tolerates a query string, a hash and a trailing slash.
 *
 * @param {string} pathname
 * @returns {boolean}
 */
export function isSsrToolPage(pathname) {
  if (!pathname) return false;
  const clean = pathname.split('?')[0].split('#')[0].replace(/\/+$/, '');
  return LOOKUP.has(clean);
}
